import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Collect from "@/pages/Collect";
import EntriesList from "@/pages/EntriesList";
import Editorial from "@/pages/Editorial";
import AdminUsers from "@/pages/AdminUsers";

const Protected = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-sm">Loading observatory…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const ThemedToaster = () => {
  const { theme } = useTheme();
  return <Toaster position="top-right" theme={theme} richColors />;
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <ThemedToaster />
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/collect" element={<Collect />} />
              <Route path="/input" element={<EntriesList status="input" title="Input Database" subtitle="Newly collected entries awaiting editorial review" />} />
              <Route path="/editorial" element={<EntriesList status="editorial" title="Editorial Folder" subtitle="Entries selected for editorial content" />} />
              <Route path="/working" element={<EntriesList status="working" title="Reference Database" subtitle="Entries saved to the working reference database" />} />
              <Route path="/archive" element={<EntriesList status="archive" title="Archive" subtitle="Archived entries" />} />
              <Route path="/review" element={<Protected roles={["editor", "admin"]}><Editorial /></Protected>} />
              <Route path="/admin" element={<Protected roles={["admin"]}><AdminUsers /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
